export const MainConfig = {
    AppDetails: {
        app_name: "APP", 
        app_description: "Your App Description Here",
        app_identifier: "teakarreo-2e648",
        ios_app_version: "1.0.0", 
        android_app_version: 100
    },
    FirebaseConfig: {
        apiKey: "AIzaSyCMEMGc0jeSbSsYq6x2nRKi_WpDiJsAnKs",
        authDomain: "teakarreo-2e648.firebaseapp.com",
        projectId: "teakarreo-2e648",
        storageBucket: "teakarreo-2e648.appspot.com",
        messagingSenderId: "120085343946",
        appId: "1:120085343946:web:ebf6a104d53d1a8ee64e33",
        measurementId: "G-M8XT7FG511"
    },
    Google_Map_API_Key: {
        ios: "AIzaSyB_xEvLjegVaQdvFTnVKh__vQilpfiMy_s",
        android: "AIzaSyAxK6Cxb0GY8ptWkvSfQoj61tjanE8QPXo",
        web: "AIzaSyCMEMGc0jeSbSsYq6x2nRKi_WpDiJsAnKs"
    },
    facebookAppId: "877799469762250",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "",
        Buyer_Email_Address: ""
    }
}
